module.exports = __webpack_public_path__ + "static/img/bg_01.9329ce5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg_01.png
// module id = GYvM
// module chunks = 0